// extracted by mini-css-extract-plugin
export default {"product":"Product_product__rwvR1"};